import { render } from "./StaticsView.vue?vue&type=template&id=35582641"
import script from "./StaticsView.vue?vue&type=script&lang=js"
export * from "./StaticsView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__